/**
 * /automation — what runs without a client asking: the platform's linkage
 * templates (Features 71 to 74). One list since Feature 77 retired the
 * trigger templates beside them (D29); a `?tab=` an old address carries is
 * ignored. It takes Linkages' place in Catalog (Feature 74 D9).
 */
import { Link } from 'react-router-dom';

import { ListShape } from '../../ui/shapes.js';
import { LinkagesTab, NewLinkageAction } from '../linkages/LinkagesTab.js';
import { NEW_WITH_TOUR } from '../linkages/tour.js';

export function AutomationPage() {
  return (
    <ListShape
      title="Automation"
      subtitle={
        <>
          What runs without a client asking: linkages, defined here and switched on per
          organization. <Link to={NEW_WITH_TOUR}>How it works</Link>
        </>
      }
      action={<NewLinkageAction />}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 22, paddingBottom: 64 }}>
        <LinkagesTab />
      </div>
    </ListShape>
  );
}
